import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '../../typography';
export function FormGroup({ label, children }) {
    return (_jsxs("div", { className: "flex flex-col gap-2.5", children: [_jsx(Text, { as: "h3", type: "xs", className: "uppercase", children: label }), children] }));
}
